import React, { useEffect, useMemo } from "react";
import { Select } from "antd";
import { findInterval } from "../../../../utils/findInterval";

export const ScoreFilterWithInterval = ({
    selectedFieldDriverName,
    setSelectedFieldDriverName,
    metaDataDrivers,
    driverInterval,
    setDriverInterval,
    metadata,
    setDisplayName,
    widget,
}) => {
    const selectedMetadata = metadata?.find(
        (value) => value.name === selectedFieldDriverName
    );

    const { intervals } = useMemo(() => {
        if (selectedMetadata) {
            return findInterval(selectedMetadata);
        }
        return { suitableInterval: null, intervals: [] };
    }, [selectedMetadata]);

    const sortedIntervals = useMemo(() => {
        return [...intervals].sort((a, b) => a - b);
    }, [intervals]);

    useEffect(() => {
        if (sortedIntervals.length > 0) {
            setDriverInterval(sortedIntervals[0]);
        }
    }, [selectedFieldDriverName, sortedIntervals, setDriverInterval]);

    return (
        <div style={{ display: "flex", gap: "10px", flexDirection: "column" }}>
            <Select
                showSearch
                style={{ width: 150 }}
                placeholder="Select Filter Driver Field"
                value={
                    selectedFieldDriverName
                        ? selectedFieldDriverName
                        : metaDataDrivers[0]?.name
                }
                onChange={(value) => {
                    setSelectedFieldDriverName(value);
                    setDisplayName(`${widget.text} ${value}`);
                }}
                options={metaDataDrivers}
                fieldNames={{ label: "name", value: "name" }}
                size="small"
            />

            {/*<Select*/}
            {/*    style={{ width: 150 }}*/}
            {/*    placeholder="Select Interval"*/}
            {/*    value={driverInterval || sortedIntervals[0]}*/}
            {/*    onChange={(value) => {*/}
            {/*        setDriverInterval(value);*/}
            {/*    }}*/}
            {/*    options={sortedIntervals.map((interval) => ({*/}
            {/*        label: `${interval}`,*/}
            {/*        value: interval,*/}
            {/*    }))}*/}
            {/*    size="small"*/}
            {/*    disabled={!sortedIntervals.length}*/}
            {/*/>*/}
        </div>
    );
};
